import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { Skeleton } from '../common/skeleton/Skeleton';
import './HelpCenter.scss';
const HelpCenterSkeleton = () => {
  return (
    <Container fluid className="help-center">
      <div className="d-flex justify-content-left align-items-center">
        {[1, 2].map((item, index) => (
          <div className="help-card card" key={index}>
            <div className="help-card-content">
              <Skeleton
                count={1}
                width={80}
                height={80}
                circle={true}
                containerClassName={'help-svg-skeleton'}
              />

              <div className="help-card-name">
                <Skeleton count={1} width={100} />
              </div>
              <p>
                <span>
                  <Skeleton count={1} width={230} height={100} />
                </span>
              </p>
              <a className="download_document">
                <Skeleton count={1} width={150} height={20} />
              </a>
            </div>
          </div>
        ))}
      </div>
    </Container>
  );
};
export default HelpCenterSkeleton;
